import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BulkUploadService {

  constructor(private http: HttpClient) {
  }

  public upload(data: FormData) {

    return this.http.post<any>('dealers/report/upload/', data, {
      reportProgress: true,
      observe: 'events'
    }).pipe(map((event) => {
        switch (event.type) {

          // We do assume here, that uploading the file takes around 20% of the total processing time
          case HttpEventType.UploadProgress: {
            const progress = Math.round(20 * event.loaded / event.total);
            return { finished: false, processing: true, progress: progress };
          }

          case HttpEventType.Response: {
            const progress = Math.round(20 + 0.8 * event.body.progress);
            return {
              errors: event.body.errors,
              finished: event.body.finished,
              processing: !event.body.finished,
              progress: progress,
              uploadId: event.body.uploadId
            };
          }

          default:
            return null;
        }
      })
    );
  }

  public checkStatus(uploadId: string) {
    return this.http.get(`dealers/report/upload/${uploadId}/`)
      .pipe(map((response: { errors?: string[]; finished: boolean; progress?: number; uploadId?: string }) => {
        return {
          errors: response.errors,
          finished: response.finished,
          processing: !response.finished,
          progress: Math.round(20 + 0.8 * response.progress),
          uploadId: response.finished ? '' : response.uploadId
        };
      }));
  }

}
